// Keep the created comment and completed attachments when a later upload fails.
// The same draft object is reused by the composer until the entire action succeeds.
export async function submitCommentFiles(draft, text, files, operations) {
    if (!draft.id) {
        const created = await operations.create(text);
        draft.id = created.id;
        draft.text = text;
        draft.uploaded = [];
    } else if (draft.text !== text) {
        await operations.update(draft.id, text);
        draft.text = text;
    }
    for (const file of files || []) {
        if (draft.uploaded.includes(file)) continue;
        await operations.upload(draft.id, file);
        draft.uploaded.push(file);
    }
    return draft.id;
}
